import VDMDashboardInspection from "components/app/vdmdashboard/inspection/VDMDashboardInspection";
import React from "react";

type ScreenVDMDashboardInspectionType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardInspection: React.FC<ScreenVDMDashboardInspectionType> = (
	props: ScreenVDMDashboardInspectionType
) => {
	return <VDMDashboardInspection vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardInspection;